export default {
  state: {
    choicesId: [],
  },
  mutations: {
    setChoicesId(state, payload) {
      console.log("payload", payload);
      if (!state.choicesId.includes(payload)) {
        state.choicesId.push(payload).filter((id) => id);
      }
    },
  },
  getters: {
    choicesId(state) {
      return state.choicesId;
    },
  },
};
